import { Box, CircularProgress, Typography } from "@mui/material";
import { BarChart } from "@mui/x-charts";
import { asMillions, asUsDate } from "components/ui/formatters";
import { useGetStatsQuery } from "features/trading/accounts";

export const AumChart = () => {
  const { data, isLoading } = useGetStatsQuery();

  if (!isLoading && data && data.results?.length > 0) {
    return (
      <Box>
        <Typography variant="h5">
          AUM: {asMillions(data.results[data.results.length - 1].total_market_value)}
        </Typography>
        <BarChart
          series={[
            {
              data: data.results.map((result) => result.total_market_value),
              // The tooltip amount, which is otherwise the raw number.
              valueFormatter: asMillions,
            },
          ]}
          height={360}
          xAxis={[
            {
              data: data.results.map((result) => result.as_of_date),
              scaleType: "band",
              // Drives both the tick labels and the tooltip's date header.
              valueFormatter: asUsDate,
            },
          ]}
          sx={{ width: 100, height: 100, color: "blueviolet" }}
        />
      </Box>
    );
  } else {
    return <CircularProgress />;
  }
};
